webpackJsonp([39],{

/***/ "L4iW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Paper.default;
  }
});

var _Paper = _interopRequireDefault(__webpack_require__("P4HR"));

/***/ }),

/***/ "P4HR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("BB4/");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__("oMBP"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("nDqF"));

var _extends2 = _interopRequireDefault(__webpack_require__("pd3r"));

var _react = _interopRequireDefault(__webpack_require__("GiK3"));

var _propTypes = _interopRequireDefault(__webpack_require__("KSGD"));

var _classnames = _interopRequireDefault(__webpack_require__("HW6M"));

var _warning = _interopRequireDefault(__webpack_require__("mG8X"));

var _withStyles = _interopRequireDefault(__webpack_require__("3XyW"));

var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0, _extends2.default)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};

exports.styles = styles;

function Paper(props) {
  var classes = props.classes,
      classNameProp = props.className,
      Component = props.component,
      square = props.square,
      elevation = props.elevation,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation"]);
   false ? (0, _warning.default)(elevation >= 0 && elevation < 25, "Material-UI: this elevation `".concat(elevation, "` is not implemented.")) : void 0;
  var className = (0, _classnames.default)(classes.root, classes["elevation".concat(elevation)], (0, _defineProperty2.default)({}, classes.rounded, !square), classNameProp);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: className
  }, other));
}

Paper.propTypes =  false ? {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: _propTypes.default.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: _propTypes.default.bool
} : {};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiPaper'
})(Paper);

exports.default = _default;

/***/ }),

/***/ "dtML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tos = __webpack_require__("eI+d");

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tos).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "eI+d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _ContentWrapper = __webpack_require__("yfaX");

var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tos = function Tos() {
    var StyledThing = _styledComponents2.default.article.withConfig({
        displayName: 'Tos__StyledThing',
        componentId: 'sc-s3oqg9-0'
    })(['\n\n    ']);

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            _reactHelmet.Helmet,
            null,
            _react2.default.createElement('meta', { name: 'robots', content: 'noindex, nofollow' })
        ),
        _react2.default.createElement(
            'article',
            { role: 'article', about: '/legal/agb', 'typeof': 'schema:WebPage' },
            _react2.default.createElement(
                _ContentWrapper2.default,
                null,
                _react2.default.createElement('span', {
                    property: 'schema:name',
                    content: 'Terms and Conditions',
                    className: 'stolo-hidden'
                }),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h1',
                        null,
                        'General Terms and Conditions with Customer Information'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        'Table of Contents'
                    ),
                    _react2.default.createElement(
                        'ol',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Scope of application'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Conclusion of the contract'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Right of withdrawal'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Prices and payment terms'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Delivery and shipping terms'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Granting of usage rights for digital content'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Retention of title'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Liability for defects (warranty)'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Liability'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Special terms for the processing of goods according to particular specifications of the customer'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Redemption of promotional vouchers'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Redemption of gift vouchers'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Applicable law'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Place of jurisdiction'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Alternative dispute resolution'
                        )
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '1) Scope of application'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.1'
                        ),
                        '\xA0These General Terms and Conditions (hereinafter "T&Cs") of Becker & Karsten UG (haftungsbeschr\xE4nkt) (hereinafter "we/us") apply to all contracts for the supply of goods that you, as a consumer or entrepreneur (hereinafter \u201Eyou\u201C), conclude with us with regard to the goods presented in our online shop. We hereby object to the inclusion of your own terms, unless we have agreed otherwise with you.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.2'
                        ),
                        '\xA0For contracts for the supply of vouchers, these T&Cs apply accordingly, unless otherwise stipulated in this respect.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.3'
                        ),
                        '\xA0For contracts for the provision of digital content, these T&Cs apply accordingly, unless otherwise stipulated in this respect. Digital content within the meaning of these T&Cs is data that is created and provided in digital form.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.4'
                        ),
                        '\xA0You are a consumer within the meaning of these T&Cs if you conclude a legal transaction for purposes that can predominantly be attributed neither to your commercial nor to your self-employed professional activity.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '1.5'
                        ),
                        '\xA0You are an entrepreneur within the meaning of these T&Cs if, as a natural or legal person or as a partnership with legal capacity, you are acting in the exercise of your commercial or self-employed professional activity when concluding a legal transaction.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '2) Conclusion of the contract'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.1'
                        ),
                        '\xA0The product descriptions contained in our online shop do not constitute binding offers on our part, but rather serve to enable you to submit a binding offer.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.2'
                        ),
                        '\xA0You can submit the offer via the online order form integrated into our online shop. In doing so, after placing the selected goods in the virtual shopping cart and completing the electronic ordering process, you submit a legally binding contractual offer with regard to the goods contained in the shopping cart by clicking the button that concludes the ordering process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.3'
                        ),
                        '\xA0We can accept your offer within five days,'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'by sending you a written order confirmation or an order confirmation in text form (fax or e-mail), whereby in this respect the receipt of the order confirmation by you is decisive, or'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'by delivering the ordered goods to you, whereby in this respect the receipt of the goods by you is decisive, or'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'by requesting payment from you after you have submitted your order.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If several of the aforementioned alternatives apply, the contract is concluded at the point in time at which one of the aforementioned alternatives first occurs. The period for accepting your offer begins on the day after the dispatch of your offer and ends at the end of the fifth day following the dispatch of the offer. If we do not accept your offer within the aforementioned period, this is deemed a rejection of the offer, with the consequence that you are no longer bound by your declaration of intent.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.4'
                        ),
                        '\xA0If you select a payment method offered by PayPal, payment processing is carried out via the payment service provider PayPal (Europe) S.\xE0 r.l. et Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxemburg (hereinafter: \u201EPayPal\u201C), subject to the PayPal Terms of Use, available at ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.paypal.com/de/legalhub/paypal/useragreement-full',
                                target: '_blank' },
                            'https://www.paypal.com/de/legalhub/paypal/useragreement-full'
                        ),
                        ' or \u2013 if you do not have a PayPal account \u2013 subject to the terms for payments without a PayPal account, available at ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.paypal.com/de/legalhub/paypal/privacywax-full',
                                target: '_blank' },
                            'https://www.paypal.com/de/legalhub/paypal/privacywax-full'
                        ),
                        '. If you pay by means of a payment method offered by PayPal and selectable in the online ordering process, we already now declare the acceptance of your offer at the point in time at which you click the button that concludes the ordering process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.5'
                        ),
                        '\xA0When ordering via our online order form, we store the contract text after the conclusion of the contract and send it to you in text form (e.g. e-mail, fax or letter) after you have dispatched your order. We do not make the contract text accessible beyond this. If, prior to dispatching your order, you have set up a user account in our online shop, your order data is archived on our website and can be retrieved by you free of charge via your password-protected user account by providing the corresponding login data.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.6'
                        ),
                        '\xA0Before bindingly submitting the order via our online order form, you can identify possible input errors by carefully reading the information displayed on the screen. An effective technical means for better recognition of input errors can be the zoom function of your browser, with the help of which the display on the screen is enlarged. You can correct your entries within the electronic ordering process using the usual keyboard and mouse functions until you click the button that concludes the ordering process.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.7'
                        ),
                        '\xA0Different languages are available to you for the conclusion of the contract. The specific choice of language is displayed in the online shop.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '2.8'
                        ),
                        '\xA0Order processing and contact generally take place by e-mail and automated order processing. You must ensure that the e-mail address you provide for order processing is correct, so that the e-mails we send can be received at this address. In particular, when using SPAM filters, you must ensure that all e-mails sent by us or by third parties commissioned by us with order processing can be delivered.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '3) Right of withdrawal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.1'
                        ),
                        '\xA0Consumers are generally entitled to a right of withdrawal.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.2'
                        ),
                        '\xA0Further information on the right of withdrawal can be found in our withdrawal policy (Widerrufsbelehrung).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '3.3'
                        ),
                        '\xA0The right of withdrawal does not apply to consumers who, at the time of the conclusion of the contract, do not belong to any member state of the European Union and whose sole place of residence and delivery address at the time of the conclusion of the contract are outside the European Union.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '4) Prices and payment terms'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.1'
                        ),
                        '\xA0Unless otherwise stated in our product description, the prices indicated are total prices that include the statutory value added tax. Any additional delivery and shipping costs that may apply are stated separately in the respective product description.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.2'
                        ),
                        '\xA0In the case of deliveries to countries outside the European Union, additional costs may arise in individual cases that we are not responsible for and that are to be borne by you. These include, for example, costs for the transfer of money by credit institutions (e.g. transfer fees, exchange rate fees) or import duties or taxes (e.g. customs duties). Such costs may also arise with regard to the transfer of money even if the delivery is not made to a country outside the European Union, but you make the payment from a country outside the European Union.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.3'
                        ),
                        '\xA0The payment option(s) available to you will be communicated to you in our online shop.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.4'
                        ),
                        '\xA0If payment in advance by bank transfer is agreed, payment is due immediately after conclusion of the contract, unless we have agreed a later due date with you.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.5'
                        ),
                        '\xA0If you select a payment method offered via the payment service "Shopify Payments", payment processing is carried out by the payment service provider Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland (hereinafter "Stripe"). The individual payment methods offered via Shopify Payments will be communicated to you in our online shop. To process payments, Stripe may use further payment services for which special payment terms may apply, to which you may be separately referred. Further information on "Shopify Payments" is available on the internet at ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://www.shopify.com/legal/terms-payments-de',
                                target: '_blank' },
                            'https://www.shopify.com/legal/terms-payments-de'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '4.6'
                        ),
                        '\xA0If you select a payment method offered via the payment service \u201EStripe\u201C, payment processing is carried out via the payment service provider Stripe Payments Europe Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland (hereinafter "Stripe"). The individual payment methods offered via Stripe will be communicated to you in our online shop. To process payments, Stripe may use further payment services for which special payment terms may apply, to which you may be separately referred. Further information on Stripe is available on the internet at ',
                        _react2.default.createElement(
                            'a',
                            {
                                href: 'https://stripe.com/de',
                                target: '_blank' },
                            'https://stripe.com/de'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '5) Delivery and shipping terms'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.1'
                        ),
                        '\xA0If we offer to ship the goods, delivery takes place within the delivery area we specify to the delivery address you specify, unless otherwise agreed. In the processing of the transaction, the delivery address specified in our order processing is decisive.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.2'
                        ),
                        '\xA0If delivery of the goods fails for reasons for which you are responsible, you bear the reasonable costs incurred by us as a result. This does not apply with regard to the costs for the outbound shipment if you effectively exercise your right of withdrawal. With regard to the return shipping costs, in the event of an effective exercise of the right of withdrawal by you, the provision set out in our withdrawal policy in this respect applies.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.3'
                        ),
                        '\xA0If you are acting as an entrepreneur, the risk of accidental loss and accidental deterioration of the sold goods passes to you as soon as we have delivered the item to the carrier, the freight forwarder or the person or institution otherwise designated to carry out the shipment. If you are acting as a consumer, the risk of accidental loss and accidental deterioration of the sold goods generally passes only upon handover of the goods to you or to a person authorized to receive them. Notwithstanding this, the risk of accidental loss and accidental deterioration of the sold goods, even if you are acting as a consumer, passes to you as soon as we have delivered the item to the carrier, the freight forwarder or the person or institution otherwise designated to carry out the shipment, if you have commissioned the carrier, the freight forwarder or the person or institution otherwise designated to carry out the shipment with the execution and we have not previously named this person or institution to you.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.4'
                        ),
                        '\xA0We reserve the right to withdraw from the contract in the event of incorrect or improper delivery to us. This applies only in the case that the non-delivery is not our responsibility and we have concluded a specific covering transaction with the supplier with the requisite care. We will make all reasonable efforts to procure the goods. In the event of non-availability or only partial availability of the goods, you will be informed without delay and the consideration will be refunded to you without delay.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.5'
                        ),
                        '\xA0Collection in person is not possible for logistical reasons.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.6'
                        ),
                        '\xA0Vouchers are provided to you as follows:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'by e-mail'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'by post'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '5.7'
                        ),
                        '\xA0Digital content is provided to you as follows:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '- by download'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '6) Granting of usage rights for digital content'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '6.1'
                        ),
                        '\xA0Unless otherwise stated in the content description in our online shop, we grant you the non-exclusive right, unlimited in terms of place and time, to use the provided content for private as well as for commercial purposes.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '6.2'
                        ),
                        '\xA0Passing on the content to third parties or creating copies for third parties outside the scope of these T&Cs is not permitted, unless we have consented to a transfer of the license that is the subject of the contract to the third party.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '6.3'
                        ),
                        '\xA0Insofar as the contract relates to the one-time provision of a digital content, the granting of rights only becomes effective once you have paid the contractually owed remuneration in full. We may also provisionally permit use of the content that is the subject of the contract before this point in time. No transfer of rights takes place through such a provisional permission.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '7) Retention of title'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If we perform in advance, we retain title to the delivered goods until full payment of the purchase price owed.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '8) Liability for defects (warranty)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Unless otherwise stated in the following provisions, the provisions of statutory liability for defects apply. Deviating from this, the following applies to contracts for the supply of goods:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.1'
                        ),
                        '\xA0If you are acting as an entrepreneur,'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'we have the choice of the type of subsequent performance;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'for new goods, the limitation period for claims based on defects is one year from delivery of the goods;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'for used goods, claims based on defects are excluded;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'the limitation period does not begin anew if a replacement delivery is made within the scope of liability for defects.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.2'
                        ),
                        '\xA0The limitations of liability and reductions of periods set out above do not apply'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'to your claims for damages and reimbursement of expenses,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'in the event that we have fraudulently concealed the defect,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'for goods that have been used for a building in accordance with their customary use and have caused its defectiveness,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'to any obligation we may have to provide updates for digital products, in the case of contracts for the supply of goods with digital elements.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.3'
                        ),
                        '\xA0In addition, for entrepreneurs the statutory limitation periods for any statutory right of recourse remain unaffected.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.4'
                        ),
                        '\xA0If you are acting as a merchant within the meaning of \xA7 1 HGB (German Commercial Code), the commercial duty to examine and give notice of defects pursuant to \xA7 377 HGB applies to you. If you fail to give the notices regulated there, the goods are deemed approved.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '8.5'
                        ),
                        '\xA0If you are acting as a consumer, you are requested to report delivered goods with obvious transport damage to the deliverer and to inform us of this. If you fail to do so, this has no effect whatsoever on your statutory or contractual claims based on defects.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '9) Liability'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The seller is liable to you for all contractual, quasi-contractual and statutory claims, including claims in tort, for damages and reimbursement of expenses as follows:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.1'
                        ),
                        '\xA0We are liable without limitation on any legal ground'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'in the case of intent or gross negligence,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'in the case of intentional or negligent injury to life, body or health,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'on the basis of a guarantee promise, unless otherwise regulated in this respect,'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'on the basis of mandatory liability such as under the Product Liability Act.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.2'
                        ),
                        '\xA0If we negligently breach a material contractual obligation, liability is limited to the foreseeable damage typical for the contract, unless we are liable without limitation pursuant to the preceding paragraph. Material contractual obligations are obligations that the contract imposes on us according to its content for the achievement of the purpose of the contract, the fulfillment of which makes the proper performance of the contract possible in the first place and on the observance of which you may regularly rely.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.3'
                        ),
                        '\xA0Otherwise, our liability is excluded.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '9.4'
                        ),
                        '\xA0The above liability provisions also apply with regard to our liability for our vicarious agents and legal representatives.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '10) Special terms for the processing of goods according to particular specifications of the customer'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.1'
                        ),
                        '\xA0If, according to the content of the contract, we owe in addition to the supply of goods also the processing of the goods according to particular specifications of you, you must provide us with all content required for the processing, such as texts, images or graphics, in the file formats, formatting, image and file sizes specified by us, and grant us the usage rights required for this. You alone are responsible for the procurement of and acquisition of rights to these content. You declare and assume responsibility that you possess the right to use the content provided to us. In particular, you ensure that no rights of third parties are infringed thereby, in particular copyrights, trademark rights and personality rights.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.2'
                        ),
                        '\xA0You indemnify us against claims of third parties that they may assert in connection with an infringement of their rights through our contractual use of the content provided to us by you. In doing so, you also assume the necessary costs of legal defense, including all court and attorney costs in the statutory amount. This does not apply if the infringement is not your responsibility. In the event of a claim by third parties, you are obliged to provide us without delay, truthfully and completely with all information required for the examination of the claims and a defense.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '10.3'
                        ),
                        '\xA0We reserve the right to refuse processing orders if the content provided to us by you for this purpose violates statutory or official prohibitions or public morals. This applies in particular to the provision of unconstitutional, racist, xenophobic, discriminatory, insulting, youth-endangering and/or violence-glorifying content.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '11) Redemption of promotional vouchers'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.1'
                        ),
                        '\xA0Vouchers that we issue free of charge within the scope of promotional campaigns with a specific period of validity and that you cannot purchase (hereinafter "promotional vouchers") can only be redeemed in our online shop and only within the specified period.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.2'
                        ),
                        '\xA0Individual products may be excluded from the voucher campaign if a corresponding restriction results from the content of your promotional voucher.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.3'
                        ),
                        '\xA0Promotional vouchers can only be redeemed before the conclusion of the ordering process. Subsequent offsetting is not possible.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.4'
                        ),
                        '\xA0Only one promotional voucher can be redeemed by you per order.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.5'
                        ),
                        '\xA0Insofar as our promotional voucher relates to a specific value and not to a percentage discount, your goods value must correspond at least to the amount of the promotional voucher. Any remaining balance is not refunded by us.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.6'
                        ),
                        '\xA0If the value of the promotional voucher is not sufficient to cover your order, you can choose one of the other payment methods offered by us to settle the difference.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.7'
                        ),
                        '\xA0The balance of a promotional voucher is neither paid out in cash nor does it bear interest.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.8'
                        ),
                        '\xA0The promotional voucher is not refunded if you return the goods paid for in whole or in part with the promotional voucher within the scope of your statutory right of withdrawal.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '11.9'
                        ),
                        '\xA0The promotional voucher is transferable. We can render performance with discharging effect to the respective holder who redeems the promotional voucher in our online shop. This does not apply if we have knowledge or grossly negligent ignorance of the lack of entitlement, the legal incapacity or the lack of power of representation of the respective holder.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '12) Redemption of gift vouchers'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.1'
                        ),
                        '\xA0Vouchers that can be purchased via our online shop (hereinafter "gift vouchers") can only be redeemed in our online shop, unless otherwise stated in the voucher.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.2'
                        ),
                        '\xA0Gift vouchers and remaining balances of gift vouchers can be redeemed until the end of the third year after the year of the voucher purchase. Remaining balances are credited to you until the expiry date.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.3'
                        ),
                        '\xA0Gift vouchers can only be redeemed before the conclusion of the ordering process. Subsequent offsetting is not possible.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.4'
                        ),
                        '\xA0Gift vouchers can only be used for the purchase of goods and not for the purchase of further gift vouchers.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.5'
                        ),
                        '\xA0If the value of the gift voucher is not sufficient to cover the order, one of the other payment methods offered by us can be chosen to settle the difference.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.6'
                        ),
                        '\xA0The balance of a gift voucher is neither paid out in cash nor does it bear interest.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '12.7'
                        ),
                        '\xA0The gift voucher is transferable. The seller can render performance with discharging effect to the respective holder who redeems the gift voucher in the seller\'s online shop. This does not apply if the seller has knowledge or grossly negligent ignorance of the lack of entitlement, the legal incapacity or the lack of power of representation of the respective holder.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '13) Applicable law'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '13.1'
                        ),
                        '\xA0The law of the Federal Republic of Germany applies to all legal relationships between us, to the exclusion of the laws on the international sale of movable goods. If you are acting as a consumer, this choice of law applies only insofar as the protection granted to you by mandatory provisions of the law of the state in which you have your habitual residence is not thereby withdrawn.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'b',
                            null,
                            '13.2'
                        ),
                        '\xA0Furthermore, this choice of law does not apply with regard to the statutory right of withdrawal in the case of consumers who, at the time of the conclusion of the contract, do not belong to any member state of the European Union and whose sole place of residence and delivery address at the time of the conclusion of the contract are outside the European Union.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '14) Place of jurisdiction'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you are acting as a merchant, a legal person under public law or a special fund under public law domiciled in the territory of the Federal Republic of Germany, the exclusive place of jurisdiction for all disputes arising from this contract is our place of business. If your domicile is outside the territory of the Federal Republic of Germany, then our place of business is the exclusive place of jurisdiction for all disputes arising from this contract if the contract or claims arising from the contract can be attributed to your professional or commercial activity. In the aforementioned cases, however, we are in any case entitled to take legal action at the court of your domicile.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        '15) Alternative dispute resolution'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We are not obliged to participate in a dispute resolution procedure before a consumer arbitration board, but are willing to do so.'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { id: 'widerruf' },
                    _react2.default.createElement(
                        'h1',
                        null,
                        'Cancellation Policy & Cancellation Form'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        'A. Cancellation Policy'
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Introduction'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Consumers have a right of withdrawal subject to the following provisions, whereby a consumer is any natural person who concludes a legal transaction for purposes that can predominantly be attributed neither to their commercial nor to their independent professional activity:'
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Right of withdrawal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You have the right to withdraw from this contract within fourteen days without giving any reason.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The withdrawal period is fourteen days from the day on which you or a third party named by you, who is not the carrier, took possession of the last goods.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To exercise your right of withdrawal, you must inform us (Becker & Karsten UG (haftungsbeschr\xE4nkt), Sandhauser Str. 107, 13505 Berlin, Germany, Tel.: +49 30 609851960, Email: wir@beckerundkarsten.de) by means of a clear declaration (e.g. a letter sent by post or an email) of your decision to withdraw from this contract. You may use the attached model withdrawal form for this purpose, although it is not mandatory.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You may also exercise your right of withdrawal online on the website at the web address ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://widerruf.beckerundkarsten.de',
                                target: '_blank' },
                            'https://widerruf.beckerundkarsten.de'
                        ),
                        '. If you use this online feature, we will promptly send you an acknowledgement of receipt on a durable medium (e.g. by email), including information about the content of the withdrawal declaration as well as the date and time of its receipt.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To meet the withdrawal deadline, it is sufficient for you to send your notification concerning the exercise of the right of withdrawal before the withdrawal period has expired.'
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Consequences of withdrawal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you withdraw from this contract, we shall reimburse to you all payments received from you, including the costs of delivery (with the exception of the additional costs arising from your choice of a type of delivery other than the least expensive type of standard delivery offered by us), without undue delay and at the latest within fourteen days from the day on which we receive notification of your withdrawal from this contract. For this reimbursement, we will use the same means of payment that you used for the original transaction, unless expressly agreed otherwise with you; in no case will you be charged any fees for this reimbursement. We may withhold reimbursement until we have received the goods back or until you have supplied evidence of having sent back the goods, whichever is the earlier.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You shall send back or hand over the goods to us without undue delay and in any event no later than fourteen days from the day on which you notify us of the withdrawal from this contract. The deadline is met if you send back the goods before the period of fourteen days has expired.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You shall bear the direct cost of returning the goods.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You are only liable for any diminished value of the goods resulting from the handling of them other than what is necessary to establish the nature, characteristics and functioning of the goods.'
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Exclusion or early expiry of the right of withdrawal'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The right of withdrawal does not exist for contracts for the supply of goods that are not prefabricated and for the production of which an individual selection or determination by the consumer is decisive, or which are clearly tailored to the consumer\'s personal requirements.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The right of withdrawal does not apply to consumers who, at the time of concluding the contract, do not belong to any member state of the European Union and whose sole place of residence and delivery address at the time of concluding the contract are outside the European Union.'
                    ),
                    _react2.default.createElement(
                        'h2',
                        null,
                        'B. Cancellation Form'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you wish to withdraw from the contract, please complete this form and send it back.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Becker & Karsten UG (haftungsbeschr\xE4nkt)',
                        _react2.default.createElement('br', null),
                        'Sandhauser Str. 107',
                        _react2.default.createElement('br', null),
                        '13505 Berlin',
                        _react2.default.createElement('br', null),
                        'Germany'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Email: wir@beckerundkarsten.de'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'I/we (*) hereby withdraw from the contract concluded by me/us (*) for the purchase of the following goods (*) / the provision of the following service (*)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '_______________________________________________________'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '_______________________________________________________'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Ordered on (*) ____________ / received on (*) __________________'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '________________________________________________________',
                        _react2.default.createElement('br', null),
                        'Name of consumer(s)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '________________________________________________________',
                        _react2.default.createElement('br', null),
                        'Address of consumer(s)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '________________________________________________________',
                        _react2.default.createElement('br', null),
                        'Signature of consumer(s) (only if this form is notified on paper)'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '_________________________',
                        _react2.default.createElement('br', null),
                        'Date'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '(*) Delete as appropriate'
                    )
                )
            )
        )
    );
};

exports.default = Tos;

/***/ }),

/***/ "yfaX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Paper = __webpack_require__("L4iW");

var _Paper2 = _interopRequireDefault(_Paper);

var _styledComponents = __webpack_require__("VEsJ");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentWrapper = (0, _styledComponents2.default)(_Paper2.default).withConfig({
  displayName: 'ContentWrapper',
  componentId: 'sc-1b74oo9-0'
})(['\n  margin: ', ' 0;\n  padding: ', ';\n  position: relative;\n    \n    & p {\n      line-height: 1.61em;\n      margin-bottom: ', ';\n      max-width: ', ';\n    }\n\n    & h1, h2, h3, h4, h5, h6 {\n      margin: ', ' 0 ', ';\n    }\n    \n    & img {\n      max-width: 100%;\n    }\n\n'], function (props) {
  return props.theme.space[12];
}, function (props) {
  return props.theme.space[10];
}, function (props) {
  return props.theme.space[9];
}, function (props) {
  return props.theme.space[23];
}, function (props) {
  return props.theme.space[7];
}, function (props) {
  return props.theme.space[12];
});

exports.default = ContentWrapper;

/***/ })

});


// WEBPACK FOOTER //
// async/enTos.289d23415cce99636239.js